import React from 'react';
import Imgix from "react-imgix";

const ArtistContentImage = (props:any) => {
    const imageUrl = props.imageUrl;
    const imageTitle = props.imageTitle;
    const link = props.link !== '' ? props.link : '';

    return (
        <div className={'relative w-full'}>
            {
                imageUrl && link !== '' &&
                <a href={link}>
                    <Imgix
                        className="w-full"
                        src={ imageUrl }
                        htmlAttributes={{
                            alt: `Image for ${ imageTitle }`,
                            loading: 'lazy',
                        }}
                        disableQualityByDPR
                    />
                </a>
            }
            {
                imageUrl && link === '' &&
                <Imgix
                    className="w-full"
                    src={ imageUrl }
                    htmlAttributes={{
                        alt: `Image for ${ imageTitle }`,
                        loading: 'lazy',
                    }}
                    disableQualityByDPR
                />
            }
        </div>
    )
}

export default ArtistContentImage;